"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var currency_formatter_1 = __importDefault(require("currency-formatter"));
var CalculatorHelpers = (function () {
    function CalculatorHelpers(discountService) {
        this.discountService = discountService;
    }
    CalculatorHelpers.prototype.applyDiscount = function (value, discount) {
        if (!discount || !discount.enabled) {
            return value;
        }
        else {
            if (!discount.id && discount.units && discount.type) {
                return this.calculateDiscount(value, discount.units, discount.type);
            }
            else {
                var savedDiscount = this.discountService.findDiscountById(discount.id);
                if (!savedDiscount)
                    return value;
                return this.calculateDiscount(value, savedDiscount.amount, savedDiscount.type);
            }
        }
    };
    CalculatorHelpers.prototype.calculateDiscount = function (original, amount, type) {
        if (typeof amount === "number") {
            var discountValue = Math.abs(amount);
            if (type === "percent") {
                original = original * (1 - discountValue / 100);
            }
            else {
                original -= discountValue;
            }
            original = Math.max(original, 0);
        }
        return original;
    };
    CalculatorHelpers.prototype.roundOffMoney = function (amount, code) {
        var currencyDecimals = currency_formatter_1.default.findCurrency(code).decimalDigits;
        return Number(amount.toFixed(currencyDecimals));
    };
    return CalculatorHelpers;
}());
exports.default = CalculatorHelpers;
